const parseDigits = (string) => (string.match(/\d+/g) || []).join('');
const formatStringToMMddyyyy = (string) => {
    const digits = parseDigits(string);
    const chars = digits.split('');
    return chars
        .reduce((r, v, index) => (index === 2 || index === 4 ? `${r}/${v}` : `${r}${v}`), '')
        .substr(0, 10);
};

export default formatStringToMMddyyyy;
